// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
//@components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ShippingAddress = require('components/commons/shippingAddress/shippingAddress');
class HireCardRevolvingStep4 extends React.Component {

    render() {
        const { immHireContactData, immShippingAddressList, setShippingAddress } = this.props;
        const isShippingAddressFeatching = immShippingAddressList.get('shippingAddressList');
        let shippingAddressBlock = <LoadingSection />;
        if(!!isShippingAddressFeatching) {
            shippingAddressBlock = (
                <ShippingAddress
                    immHireContactData={immHireContactData}
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                />
            )
        }
        return (
            <article className="row hire-card-revolving-step-four">
                <div className="col-sm-12">
                    {shippingAddressBlock}
                </div>
            </article>
        );
    }
}

HireCardRevolvingStep4.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    setShippingAddress: PropTypes.func,
};

module.exports = HireCardRevolvingStep4;
